<div class="inline-content" [formGroup]="form">
  <shared-input-number formControlName="count" [min]="1" [max]="9999" [maxLength]="4" [fixValueOnBlur]="true" />
  <div class="select-content-width">
    <mat-button-toggle-group formControlName="multiplier" (change)="onValueChange()" hideSingleSelectionIndicator="true">
      <mat-button-toggle [value]="DateHelper.msPerMinute">minutes</mat-button-toggle>
      <mat-button-toggle [value]="DateHelper.msPerHour">hours</mat-button-toggle>
      @if (showDays) {
        <mat-button-toggle [value]="DateHelper.msPerDay">days</mat-button-toggle>
      }
    </mat-button-toggle-group>
  </div>
</div>
